<template>
     <v-container>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
          Chair
        </div>    
        <br>  
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
           <span v-for="(content, index) in contents" :key="content['id']">
               {{ section }}.{{ index + 1 }} {{ content.question }} <br>
               Answer: {{ forms.chair_score[index] ? 'Yes' : 'No' }} <br>
               Comment: {{ forms.chair_comment[index] }} <br> <br>
            </span>
        </div>
     </v-container>
</template>
<script>
import Scale from '@/components/Scale';
import db from '@/components/firebase.init';
export default {
    props:['section','forms'],
    data(){
        return{
          contents:[
                {
                    question:"Is the chair adjustable to suit the work tasks?",
                    parts: ['Back', 'Knee', 'Elbow']
                },
                {
                    question:"Does the chair provide the user with lumbar support?",
                    parts: ['Back']
                },
                {
                    question:"Does the chair have five support legs?",
                    parts: ['Back']
                },
                {
                    question:"Does the chair have appropriate casters for the rolling surface (hard/soft surface)?",
                    parts: ['Back']
                },
                {
                    question:"Are the employee’s feet flat on the floor when sitting on the chair?",
                    parts: ['Back', 'Knee']
                },
                {
                    question:"Does the chair have adjustable armrests?",
                    parts: ['Elbow']
                },
                {
                    question:"When sitting on chair, are the employee’s thigh parallel to the floor?",
                    parts: ['Knee']
                },
                {
                    question:"When sitting on chair, are the employee’s knees 90-degree angle",
                    parts: ['Knee']
                },
                {
                    question:"Does the employee have knowledge as to how to adjust the chair",
                    parts: ['General']
                }
            ]
        }
    },
    methods:{
       
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.chair_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

